import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate, useParams } from "react-router-dom";
import { searchJob, toggleFilter, toggleSort } from "../../features/filter/filterSlice";
import { createJob, fetchSingleJob, updateJob } from "../../features/job/jobSlice";

const UpdateForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {jobId} = useParams();
  const match = useMatch('/form')

  const [editMode, setEditMode] = useState(false);

  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [deadline, setDeadline] = useState("");
  const [salary, setSalary] = useState("");

  const {editing, isLoading, isError} = useSelector((state) => state.job);

 const resetForm = () => {
    setTitle("");
    setType("");
    setDeadline("");
    setSalary("");
 }

  useEffect(() => {
    if(jobId){
        dispatch(fetchSingleJob(jobId));
        setEditMode(true)
    }
  },[jobId])

  useEffect(() => {
    if(match){
        resetForm()
    }
    if(!match && editing.id){
        const {title, type, deadline, salary} = editing;
        setTitle(title);
        setType(type);
        setDeadline(deadline);
        setSalary(salary);
    }
    
  },[editing, match])

  if(isLoading){
    return <div>Loadding...</div>
  }

  const handleCreate = (e) => {
    e.preventDefault();

    const data = {
      title,
      type,
      deadline,
      salary: Number(salary),
    };

    dispatch(createJob(data));
    navigate('/');
    dispatch(toggleFilter(''))
    dispatch(toggleSort(''))
    resetForm()
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const data = {
        id: editing.id,
        title,
        type,
        deadline,
        salary: Number(salary)
    }

    dispatch(updateJob({
        data,
        id: editing.id
    }))
    navigate('/');
    dispatch(toggleFilter(''))
    dispatch(toggleSort(''))
    resetForm();
  }
  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center lws-section-title">{editMode ? "Edit Job" :"Add New Job"}</h1>

      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={editMode ? handleUpdate : handleCreate}>
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              id="lws-JobTitle"
              name="lwsJobTitle"
              required
              value={title || ""}
              onChange={(e) => setTitle(e.target.value)}
            >
              <option value="">
                Select Job
              </option>
              <option>Software Engineer</option>
              <option>Software Developer</option>
              <option>Full Stack Developer</option>
              <option>MERN Stack Developer</option>
              <option>DevOps Engineer</option>
              <option>QA Engineer</option>
              <option>Product Manager</option>
              <option>Social Media Manager</option>
              <option>Senior Executive</option>
              <option>Junior Executive</option>
              <option>Android App Developer</option>
              <option>IOS App Developer</option>
              <option>Frontend Developer</option>
              <option>Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              id="lws-JobType"
              name="lwsJobType"
              required
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="" hidden selected>
                Select Job Type
              </option>
              <option>Full Time</option>
              <option>Internship</option>
              <option>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              value={deadline}
              onChange={(e) => setDeadline(e.target.value)}
              required
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              {editMode? "Edit" : "Add"}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default UpdateForm;
